export default {
  successful: "successful",
  fail: "fail",

  notification_settings_successfully_message:
    "The settings has been save successfully",
  command_send_successfully: "Command has been sent to device successfully",
  device_shutdown_successfully: "Device shutdown successfully",
  device_reboot_successfully: "Device rebooted successfully",
  command_fail: "There is a problem to shutdown",
  password_changed_fail: "There is a problem in changing account's password.",
  password_changed_successfully:
    " “{{name}}” account's password changed successfully.",
  account_created_successfully: "User account created successfully.",
  account_created_fail: "There is a problem in creating new account.",
  account_created_successfully_desc: "“{{name}}” account is now active.",
  account_deleted_successfully: "Account deleted successfully!",
  account_deleted_fail: "There is a problem in removing the account.",
  account_deleted_successfully_desc:
    "User “{{name}}” ’s account has been successfully removed.",
  account_suspended_successfully: "Account suspended successfully!",
  account_suspended_fail: "There is a problem in suspending the account.",
  account_suspended_successfully_desc: "User “{{name}}” has been deactivated.",
  account_activated_successfully: "Account activated successfully!",
  account_activated_fail: "There is a problem in activating the account.",
  account_activated_successfully_desc: "User “{{name}}” is activated.",
  account_privilege_successfully: "Privilege changed successfully!",
  account_privilege_fail:
    "There is a problem in changing the account's privilege.",
  account_privilege_successfully_desc:
    "User “{{name}}” privilege is changed to {{privilege}}.",
  command_sent_successfully: "{{command}} command sent successfully.",
  command_sent_to_device_successfully:
    "{{command}} command has been sent to device successfully.",
  updated_successfully:
    "Updating all software command has been sent to device successfully.",
  updated_failure: "There is a problem in updating device's software",
  unenroll_confirm: "Do you want to unenroll this device?",
  unenroll_confirm_description:
    "By choosing ‘Unenroll’, Trio will no longer manage your device. Do you wish to proceed?",
  service_confirm_title: "Confirmation?",
  service_confirm_desc: "Do you confirm to {{action}} the <b>{{name}}</b>?",
  send_blank_push_confirmation:
    "Are you sure you want to send a blank push notification?",
  device_send_blank_fail:
    "There is a problem to send blank push to the device.",

  // update
  unassign_app_success: "Application has been un-assign from user successfully",
  unassign_app_confirm_title: "Unassign Application?",
  unassign_app_confirm_description:
    "Are you sure you want unassign application from user?",
  geofence_crete_success: "Geofence created successfully",
  geofence_updated_success: "Geofence updated successfully",
  geofence_deleted_success: "Geofence has been deleted successfully",
  delete_geofence_confirm_title: 'Are you sure you want to remove "{{name}}"',
};
